/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IAGLoanStorage,
  IAGLoanStorageInterface,
} from "../IAGLoanStorage";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unloanAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "fee30Days",
            type: "uint16",
          },
        ],
        internalType: "struct IAGLoanStorage.LoanTickInfo",
        name: "tick",
        type: "tuple",
      },
    ],
    name: "addTick",
    outputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    name: "getTick",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unloanAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "fee30Days",
            type: "uint16",
          },
        ],
        internalType: "struct IAGLoanStorage.LoanTickInfo",
        name: "tick",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    name: "removeTick",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IAGLoanStorage__factory {
  static readonly abi = _abi;
  static createInterface(): IAGLoanStorageInterface {
    return new utils.Interface(_abi) as IAGLoanStorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAGLoanStorage {
    return new Contract(address, _abi, signerOrProvider) as IAGLoanStorage;
  }
}
